import React from "react";
import styles from "./AccountInactive.module.sass";
import cn from "classnames";
import { Link } from "react-router-dom";
import { use100vh } from "react-div-100vh";
import Image from "../../components/Image";

const AccountInactive = () => {
  const heightWindow = use100vh();

  return (
    <div className={styles.row}>
      <div 
        className={styles.col}
        style={{
          backgroundImage: `url('/images/content/loginbg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          flex: 1
        }}
      />
      <div className={styles.col} style={{ minHeight: heightWindow, flex: 1.5}}>
        <div className={styles.head}>
          <Link className={styles.logo} to="/">
            <Image
              className={styles.pic}
              src="/images/logo.png"
              srcDark="/images/logo.png"
              alt="WakeUpSuccess"
            />
          </Link>
          <div className={styles.info}>
            <Link className={styles.link} to="/sign-in">
              Retour à la connexion
            </Link>
          </div>
        </div>
        <div className={styles.wrapper}>
          <div className={cn("h2", styles.title)}>Compte désactivé</div>
          
          <div className={styles.body}>
            <div className={styles.messageContainer}>              
              <div className={styles.message}>
                Votre compte a été temporairement désactivé.
              </div>
              
              <div className={styles.submessage}>
                Merci de contacter un membre du personnel pour la réactivation de votre compte.
              </div>
            </div>
            
            <Link 
              to="/sign-in" 
              className={cn("button", styles.button)}
            >
              Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountInactive;
